import { render, staticRenderFns } from "./ModalAddMoreSkill.vue?vue&type=template&id=408dee72&"
import script from "./ModalAddMoreSkill.vue?vue&type=script&lang=js&"
export * from "./ModalAddMoreSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports